"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ModalForm = _interopRequireDefault(require("./ModalForm.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// JSON CONFIG _______________________________________________________
//
//
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row,
      loadData = _ref.loadData,
      extraData = _ref.extraData;
    return /*#__PURE__*/_react["default"].createElement(_ModalForm["default"], {
      settings: settings,
      row: row,
      loadData: loadData,
      extraData: extraData
    });
  };
};